import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import React, { useRef } from 'react';
import './../../assets/scss/form_styles.scss';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Stack, FormControl, Typography, Box, IconButton, Alert } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { colors } from '../../Themes/colors';
import moment from 'moment';
import { CloseIconSmall } from '../icons';
import { validateDate } from '../../utils/commonUtilities';
var MUIDatePicker = function (_a) {
    var labelText = _a.labelText, selectedDate = _a.selectedDate, dateChangeHandler = _a.dateChangeHandler, errorMessage = _a.errorMessage, isMandatory = _a.isMandatory, disabled = _a.disabled, minDate = _a.minDate, maxDate = _a.maxDate, clearDate = _a.clearDate, fontWeight = _a.fontWeight, name = _a.name, maxFutureDays = _a.maxFutureDays, disableManualInput = _a.disableManualInput;
    var parsedSelectedDate = selectedDate === null || selectedDate === ""
        ? null
        : moment(selectedDate);
    var pickerValue = parsedSelectedDate && parsedSelectedDate.isValid() ? parsedSelectedDate : null;
    var formattedSelectedDate = pickerValue ? pickerValue.format('MM/DD/YYYY') : '';
    var formattedSelectedDateRef = useRef(formattedSelectedDate);
    formattedSelectedDateRef.current = formattedSelectedDate;
    var parseManualInputDate = function (value) {
        var trimmedValue = value.trim();
        if (!trimmedValue) {
            return null;
        }
        return moment(trimmedValue, ['MM/DD/YYYY', 'M/D/YYYY', 'MM-D-YYYY', 'M-D-YYYY'], true);
    };
    var violatesPickerConstraints = function (value) {
        var parsedDate = parseManualInputDate(value);
        if (!parsedDate || !parsedDate.isValid()) {
            return false;
        }
        if (minDate && moment(minDate).isValid() && parsedDate.isBefore(moment(minDate).startOf('day'))) {
            return true;
        }
        if (maxDate && moment(maxDate).isValid() && parsedDate.isAfter(moment(maxDate).endOf('day'))) {
            return true;
        }
        if (maxFutureDays) {
            var today = moment().startOf('day');
            var maxAllowedDate = moment().add(maxFutureDays, 'days').endOf('day');
            if (parsedDate.isBefore(today) || parsedDate.isAfter(maxAllowedDate)) {
                return true;
            }
        }
        return false;
    };
    var resetInputToSelectedDate = function (input) {
        requestAnimationFrame(function () {
            input.value = formattedSelectedDateRef.current;
        });
    };
    var handleClearDate = function () {
        clearDate && clearDate();
    };
    var handleInputBlur = function (event) {
        if (disabled)
            return;
        var value = event.target.value.trim();
        if (value === '') {
            dateChangeHandler('');
            return;
        }
        var dateValidation = validateDate(value);
        if (!dateValidation.isValid || violatesPickerConstraints(value)) {
            dateChangeHandler(value);
            resetInputToSelectedDate(event.target);
            return;
        }
        dateChangeHandler(value);
    };
    var handleInputChange = function (event) {
        if (disabled)
            return;
        if (event.target.value === '') {
            dateChangeHandler('');
        }
    };
    return (React.createElement(Stack, { className: "date-container ".concat(disabled ? 'disable-fields' : '') },
        React.createElement(FormControl, { error: Boolean(errorMessage), className: "cstDatepicker" },
            React.createElement(DemoContainer, { components: ['DatePicker'] },
                React.createElement(DemoItem, { label: errorMessage ? React.createElement(Typography, { fontSize: '14px', className: errorMessage ? 'error' : '' },
                        React.createElement(Box, { component: 'span', color: "#d32f2f" }, labelText + "".concat(isMandatory ? '*' : '')))
                        :
                            React.createElement(Typography, { fontSize: '14px', fontWeight: fontWeight, className: errorMessage ? 'error' : '' },
                                React.createElement(React.Fragment, null,
                                    labelText ? labelText.charAt(0).toUpperCase() + labelText.slice(1) : '',
                                    isMandatory &&
                                        React.createElement(Box, { component: 'span', color: "#d32f2f" }, "*"))) },
                    React.createElement(DesktopDatePicker, { value: pickerValue, onChange: dateChangeHandler, format: "MM/DD/YYYY", className: "date-picker-styles", disabled: disabled, minDate: minDate ? moment(minDate) : null, maxDate: maxDate ? moment(maxDate) : null, shouldDisableDate: function (date) {
                            var m = moment(date);
                            if (minDate && m.isValid() && moment(minDate).isValid() && m.isBefore(moment(minDate).startOf('day'))) {
                                return true;
                            }
                            if (maxDate && m.isValid() && moment(maxDate).isValid() && m.isAfter(moment(maxDate).endOf('day'))) {
                                return true;
                            }
                            if (maxFutureDays && m.isValid()) {
                                var today = moment().startOf('day');
                                var maxAllowedDate = moment().add(maxFutureDays, 'days').endOf('day');
                                if (m.isBefore(today) || m.isAfter(maxAllowedDate)) {
                                    return true;
                                }
                            }
                            return false;
                        }, sx: {
                            '& .MuiOutlinedInput-root.Mui-disabled': {
                                backgroundColor: colors.greyShades[17],
                                '& .MuiOutlinedInput-input': {
                                    color: '#000',
                                    WebkitTextFillColor: '#000',
                                },
                            },
                        }, slotProps: {
                            textField: {
                                placeholder: "MM/DD/YYYY",
                                onBlur: disableManualInput ? undefined : handleInputBlur,
                                onChange: disableManualInput ? undefined : handleInputChange,
                                inputProps: {
                                    inputMode: "numeric",
                                    autoComplete: "off",
                                    readOnly: disableManualInput ? true : false,
                                },
                            },
                        } })),
                clearDate && selectedDate && !errorMessage &&
                    React.createElement(IconButton, { size: "small", onClick: handleClearDate, className: 'clear-date', title: "Clear Date" },
                        React.createElement(CloseIconSmall, null))),
            errorMessage && (React.createElement(Box, { sx: { mt: 1 } },
                React.createElement(Alert, { severity: "error", icon: React.createElement(ErrorOutlineIcon, { sx: { fontSize: 20 } }), sx: {
                        backgroundColor: '#fee2e2',
                        borderLeft: '4px solid #dc2626',
                        color: '#991b1b',
                        fontWeight: 500,
                        fontSize: '13px',
                        padding: '8px 12px',
                        '& .MuiAlert-icon': {
                            color: '#dc2626',
                        }
                    } }, errorMessage))))));
};
export default MUIDatePicker;
